module.exports = __webpack_public_path__ + "img/pouchkine.1ff2ee1a.jpg";